
export const NOTIFICATIONS_INLINE_ADD = 'NOTIFICATIONS_INLINE_ADD'
export const NOTIFICATIONS_INLINE_KEEP_OPEN = 'NOTIFICATIONS_INLINE_KEEP_OPEN'
export const NOTIFICATIONS_INLINE_REMOVE = 'NOTIFICATIONS_INLINE_REMOVE'
export const NOTIFICATIONS_INLINE_REMOVE_ALL = 'NOTIFICATIONS_INLINE_REMOVE_ALL'
export const NOTIFICATIONS_INLINE_REMOVE_TIMEOUT = 'NOTIFICATIONS_INLINE_REMOVE_TIMEOUT'
export const NOTIFICATIONS_INLINE_REMOVE_INTERVAL = 15000
export const NOTIFICATIONS_INLINE_OVER_LIMIT_COUNT = 3
